import { render, staticRenderFns } from "./specialties.page.vue?vue&type=template&id=9f9e6eaa&scoped=true&"
import script from "./specialties.page.vue?vue&type=script&lang=js&"
export * from "./specialties.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9e6eaa",
  null
  
)

export default component.exports